// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"oR","facetClass":"pR"};